import ActionTypes from "./ActionTypes";

const getClientDashboardData = (payload) => {
  return {
    type: ActionTypes.CLIENT_DASHBOARD,
    payload,
  };
};
const getVendorDashboardData = (payload) => {
  return {
    type: ActionTypes.VENDOR_DASHBOARD,
    payload,
  };
};

const getGuestDashboardData = (payload) => {
  return {
    type: ActionTypes.GUEST_DASHBOARD,
    payload,
  };
};

export {
  getClientDashboardData,
  getVendorDashboardData,
  getGuestDashboardData,
};
